import { getHandleId, getSourceHandleStyle, getTargetHandleStyle } from '@common-services/utils';
import { Handle, Position } from 'reactflow';
import { nodeTypes } from '../bt-nodes-def';
import NodeContainer from '../node-container';
import classes from "./condition-node.module.scss";
import CustomSourceHandle from '@common-components/bt-chatbot/custom-source-handle';
import { memo } from 'react';



type HandleSlot = { id?: string };
type ConditionNodeProps = {
    id: string;
    data: { handles?: { inputs?: HandleSlot[]; outputs?: HandleSlot[] } };
};

function ConditionNode({ id, data }: ConditionNodeProps) {

    const nodeColor = nodeTypes.condition.color



    return (
        <>
            <Handle type="target" position={Position.Left} id={getHandleId(data.handles, 'target', 0) ?? undefined}
                style={{ ...getTargetHandleStyle(nodeColor), zIndex: 3, }} />
            <NodeContainer type="condition" id={id} />
            <CustomSourceHandle type="source" position={Position.Right} id={getHandleId(data.handles, 'source', 0) ?? undefined}
                className={classes.y_handle} connectioncount={1} style={getSourceHandleStyle(nodeColor)} />
            <CustomSourceHandle type="source" position={Position.Right} id={getHandleId(data.handles, 'source', 1) ?? undefined}
                className={classes.n_handle} connectioncount={1} style={getSourceHandleStyle(nodeColor)} />
        </>
    )
}

export default memo(ConditionNode);